module.exports = __webpack_public_path__ + "img/BagMaster.e8d9531.png";